import { Cell } from './FilledDisclosuresCell.styled';

export interface FilledDisclosuresCellProps {
    children?: React.ReactNode;
    customColor?: string;
    isHighlighted?: boolean;
    isNew?: boolean;
    status?: boolean;
}

export const FilledDisclosuresCell = ({
    children,
    ...rest
}: FilledDisclosuresCellProps) => {
    return <Cell {...rest}>{children}</Cell>;
};
